module.exports = __webpack_public_path__ + "static/media/app-promo-nl@2x.aa7d83a0.png";